import React, {useEffect} from "react";
import Modal from "./index";
import { ModalProps } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

const CancelModelRepair: React.FC<ModalProps> = ({ workOrderId, area, errorCode, contractor, props }) => {
	const { t } = useTranslation();
	const [isOpen, setIsOpen] = React.useState(false);
	const [disableContinueCancelButton, setDisableContinueCancelButton] = React.useState(false);
	const isMPTContractor = contractor != null && contractor !== '' && contractor.toLowerCase().indexOf("mpt") > - 1;
	const isMPTNotificationEligible = isMPTContractor && isMPTContractor === true && errorCode === "SSR073";
	useEffect(() => {
		setDisableContinueCancelButton(["SSR066", "SSR008"].includes(errorCode) )
	}, [errorCode]);	

	const isP360Maintainence = useSelector(
	(state: any) => state.userChoicesReducer?.isP360RepairsMaintainenceValue
	);
	const history = useHistory();
	const modelOpen = () => {
    if (!isP360Maintainence) {
      if (errorCode === "" || errorCode === "SSR036") {
        history.push("/CancelRepair");
      } else {
        setIsOpen(true);
      }
    }
   };
		
	const modelClose = () => {
		setIsOpen(false)
	}
	const cancelAndExit = async () => {
	if (disableContinueCancelButton) {
	return;
	}
	setIsOpen(false);
	history.push("/CancelRepair");
	};

	return (
		<>
		    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
			<a id="exitmodal-btn1" data-testid="Cancel-button" 
				className="text-base no-underline text-black" onClick={modelOpen} onKeyDown={modelOpen}>
                <div className={"py-2 cursor-pointer text-black text-base no-underline " + (isP360Maintainence ? 'text-opacity-25 pe-none' : '')}>
                {t("CP077_CancelRepair")}
                </div>
              </a>
			
			<Modal open={isOpen} data-testid="CancelModel" 
					cssClasses="modalPopCancel max-w-144 mx-auto text-left bg-white rounded-lg shadow-lg border border-grey">
				
					<div className="absolute right-2 top-2 flex items-center justify-center text-teal w-6 h-6 p-1 rounded-full border z-50 cursor-pointer" >
						<i data-testid="CancelModelClose" 
							className="far fa-times-circle py-1 text-teal w-6 h-6 font-icon brighten"
						 onClick={modelClose}></i>
					</div>
					
					<div className="container">
					<div className="row">

						<div className="col-md-12">
							<div id="exitmodal-div2" className="py-lg-0 py-sm-0 desk-my-5 global-txt p-4 text-left">
								<h2 className="my-2 text-purple-100 text-md-left text-wrap">
								{isMPTNotificationEligible === true ? t("CP110_CancelRepair_Header") : t("CP109_CancelRepair_Header")}
								</h2>
								<p className="mb-12 mt-8 text-wrap">{
									isMPTNotificationEligible === true ? t("CP110_CancelRepair_Text") :
										errorCode === "SSR066" ? t("SSR066_CancelRepair_Text") :
											errorCode === "SSR008" ? t("SSR008_CancelRepair_Text") :
											t("CP109_CancelRepair_Text")}</p>
						
							</div>	
						</div>

						<div className="col-md-12">
							<div id="exitmodal-div3" className='px-4 md:flex md:justify-between'>						
								
								<div className="mb-4 md:mb-0 pl-6 mob-pad-x">
									{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
									<a id="exitmodal-btn2" 
										className="block  bg-teal text-white text-sm px-4 py-2 rounded no-underline cursor-pointer" 
										onClick={modelClose}>{t("CancelRepair_return_button")}
										{" >"}
									</a>
								</div>

								<div className="mb-4 md:mb-0 pr-6 mob-pad-x">
									{/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
									<a id="exitmodal-btn4"
										data-testid="exitmodal-btn4" 
										onClick={cancelAndExit}
										className={`block bg-teal text-white text-sm px-4 py-2 rounded no-underline cursor-pointer${disableContinueCancelButton? " cancel-disable " : ""}`} >
											{t("Continue_cancel")}
										{" >"}
									</a>
								</div>
							</div>
						</div>
						
					</div>
				</div>
				
			</Modal>

		</>
	);
};

export default CancelModelRepair;
